(function () {
  document
    .getElementById("contact-form")
    .addEventListener("submit", function (e) {
      var email = document.getElementById("email").value;
      var confirmEmail = document.getElementById("confirm_email").value;
      if (email !== confirmEmail) {
        e.preventDefault();
        alert("Emails do not match");
      }
    });
})();
